  removeVariantMediaUsingThumbnailMap();

  function removeVariantMediaUsingThumbnailMap() {
    const variantThumbnails = document.querySelectorAll(
      '.thumbnail-list_item--variant[data-target]'
    );

    if (!variantThumbnails.length) return;

    variantThumbnails.forEach((thumb) => {
      const targetMediaId = thumb.getAttribute('data-target');

      if (!targetMediaId) return;

      // Remove matching media item
      const matchingMedia = document.querySelector(
        `.product--media-item[data-media-id="${targetMediaId}"]`
      );

      if (matchingMedia) {
        matchingMedia.remove();
      }

      // Remove the thumbnail itself
      thumb.remove();
    });
  }


// product block bundle -- START
$('.bundle_box').on('click', function() {
  var bundle = $(this).data('bundle');
  var quantity = parseInt(bundle);
  $('.quantity__input').val(quantity);
  
  $('.bundle_box').removeClass('active');
  $(this).addClass('active');
});
// product block bundle -- END

$(document).ready(function() {
  $('.jumpbutton').on('click', function(e) {
    e.preventDefault();
    var targetKey = $(this).data('target');
    var $targetSection = $('[data-section-jump="' + targetKey + '"]');

    if ($targetSection.length) {
      $('html, body').animate({
        scrollTop: $targetSection.offset().top
      }, 600);
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('.jump_item .jumpbutton').forEach(function (link) {
    link.addEventListener('click', function (e) {
      e.preventDefault(); // prevent default jump
      const targetId = this.getAttribute('href').substring(1); // remove "#"
      const target = document.getElementById(targetId);
      if (target) {
        target.scrollIntoView({ behavior: 'smooth' });
      }
    });
  });
});


$(document).ready(function () {
    setInterval(function () {
      $(".video_testimonials_slider .slick-dots li").removeClass("slick-pn1"); // Remove previous .slick-pn classes
      $(".video_testimonials_slider .slick-dots li").removeClass("slick-pn2"); // Remove previous .slick-pn classes

        $(".video_testimonials_slider .slick-dots li").each(function () {
            if ($(this).hasClass("slick-active")) {
                let $prev = $(this).prev();
                let $next = $(this).next();

                // Add class to previous and next li
                $prev.addClass("slick-pn1");
                $next.addClass("slick-pn2");

                // If it's the first li, add to next two
                if ($(this).is(":first-child")) {
                    $next.next().addClass("slick-pn1");
                }
              
                // If it's the last li, add class to the previous two
                if ($(this).is(":last-child")) {
                    $prev.prev().addClass("slick-pn2");
                }
            }
        });

        // Show only .slick-active and .slick-pn, hide others
        $(".video_testimonials_slider .slick-dots li").each(function () {
            if ($(this).hasClass("slick-active") || $(this).hasClass("slick-pn1") || $(this).hasClass("slick-pn2")) {
                $(this).show();
            } else {
                $(this).hide();
            }
        });

    }, 100); // Adjust interval as needed
});


//======== HERO SLIDE JS START =========
$('.hero_banner_gallery').slick({
  slidesToShow: 7,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 0,
  speed: 8000,
  arrows:false,
  pauseOnHover: false,
  cssEase: 'linear',
  responsive: [
    {
      breakpoint: 9999,
      settings: "unslick"
    },
    {
      breakpoint: 769,
      settings: {
        slidesToShow: 3,
        variableWidth: true,
        slidesToScroll: 1,
      }
    }
  ]
});
//======== HERO SLIDE JS END =========

//======== FAQ JS START =========

$(document).ready(function(){
  // trusted-by-thousands start 

$('.trusted-by-thousands .testimonial-slider').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    infinite:false,
    accessibility: false, // <--- ADD THIS LINE TO FIX THE ERROR
    autoplay: true,
    autoplaySpeed: 3000,

    responsive: [
    {
    breakpoint: 1050,
    settings: {
        slidesToShow: 2.2,
        slidesToScroll: 1,
          
      }
    },
    {
    breakpoint: 768,
    settings: {
        slidesToShow: 1,
        centerMode: true,
        centerPadding: '20px',
      }
    }
  ]
});
$('.what-you-get-slider').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    infinite:false,
    accessibility: false,
    prevArrow: '<button type="button" class="slick-prev" aria-label="Previous" tabindex="0" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none"><path d="M27.5488 32.9633L18.6111 24.0255L27.5488 15.0878" stroke="#262626" stroke-width="3.13714" stroke-linecap="square" stroke-linejoin="round"/></path></svg></button>',
    nextArrow: '<button type="button" class="slick-next" aria-label="Next" tabindex="0" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none"><path d="M20.4512 32.9633L29.3889 24.0255L20.4512 15.0878" stroke="#262626" stroke-width="3.13714" stroke-linecap="square" stroke-linejoin="round"/></path></svg></button>',
    responsive: [
    {
    breakpoint: 1050,
    settings: {
        slidesToShow: 2.2,
        slidesToScroll: 1,
          
      }
    },
    {
    breakpoint: 768,
    settings: {
        slidesToShow: 1,
        centerMode: true,
        arrows: true,
        centerPadding: '20px',
      }
    }
  ]
});
  $(document).ready(function () {
    setInterval(function () {
        $(".trusted-by-thousands .testimonial-slider .slick-dots li , .what-you-get-slider .slick-dots li").removeClass("slick-pn1"); // Remove previous .slick-pn classes
      $(".trusted-by-thousands .testimonial-slider .slick-dots li , .what-you-get-slider .slick-dots li").removeClass("slick-pn2"); // Remove previous .slick-pn classes

        $(".trusted-by-thousands .testimonial-slider .slick-dots li , .what-you-get-slider .slick-dots li").each(function () {
            if ($(this).hasClass("slick-active")) {
                let $prev = $(this).prev();
                let $next = $(this).next();

                // Add class to previous and next li
                $prev.addClass("slick-pn1");
                $next.addClass("slick-pn2");

                // If it's the first li, add to next two
                if ($(this).is(":first-child")) {
                    $next.next().addClass("slick-pn1");
                }
              
                // If it's the last li, add class to the previous two
                if ($(this).is(":last-child")) {
                    $prev.prev().addClass("slick-pn2");
                }
            }
        });

        // Show only .slick-active and .slick-pn, hide others
        $(".video_testimonials_slider .slick-dots li").each(function () {
            if ($(this).hasClass("slick-active") || $(this).hasClass("slick-pn1") || $(this).hasClass("slick-pn2")) {
                $(this).show();
            } else {
                $(this).hide();
            }
        });

    }, 100); // Adjust interval as needed
});
  
  // trusted-by-thousands End

(function ($) {
  const $slider    = $('.video_testimonials_slider');
  const slideCount = $slider.children(':not(.slick-cloned)').length;
  let   slickOn    = false;

  const slickOpts = {
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    infinite: true,
    centerMode: true,
    centerPadding: '0',
    responsive: [
      // { breakpoint: 1050, settings: { slidesToShow: 1, centerPadding: '250px', centerMode: true } },
      { breakpoint: 1000, settings: { slidesToShow: 3, centerPadding: '0px',   centerMode: true } },
      { breakpoint: 768,  settings: { slidesToShow: 1, centerPadding: '100px' } },
      { breakpoint: 600,  settings: { slidesToShow: 1, centerPadding: '20px'  } }
    ]
  };

  function updateSlider () {
    const wideScreen = window.matchMedia('(min-width: 769px)').matches;

    if (slideCount < 3) {
      if (wideScreen) {
        if (slickOn) {
          $slider.slick('unslick');
          slickOn = false;
        }
        $slider.addClass('no-slick');
      } else {
        if (!slickOn) {
          $slider.slick(slickOpts);
          slickOn = true;
        }
        $slider.removeClass('no-slick');
      }
    } else {
      if (!slickOn) {
        $slider.removeClass('no-slick').slick(slickOpts);
        slickOn = true;
      }
    }
  }

  updateSlider();
  $(window).on('resize orientationchange', updateSlider);
})(jQuery);


  
// featured scroll start

$('.featured-scroll-col').slick({
  slidesToShow: 7,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 0,
  speed: 8000,
  arrows:false,
  pauseOnHover: false,
  variableWidth: true,
  cssEase: 'linear',
  responsive: [
    {
      breakpoint: 1280,
      settings: {
        slidesToShow: 6,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 3,
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2
      }
    }
  ]
});

// featured scroll end
/************************* COMMON ACCORDIAN JS START ***********************/
  
/*$('.accordion .accordion-head').click(function () {
  $(this).closest('.accordion').siblings().find('.accordion-body').slideUp(300);
  $(this).closest('.accordion').siblings().find('.accordion-body').removeClass('active');
  var sectionId = jQuery(this).parent().parent().parent().parent('div').attr('id');
  console.log("sectionId",sectionId);
  if(sectionId=='faq' || sectionId==undefined || sectionId==""){
    if(jQuery('.faq-wrapper , .ingitem.ingcontent').find('.accordion-wrapper').length>0){
      jQuery('.faq-wrapper , .ingitem.ingcontent').find('.accordion-wrapper').find('.accordion').removeClass('active');
    }
  }else if(jQuery('#'+sectionId).find('.accordion-wrapper').length>0){
    jQuery('#'+sectionId).find('.accordion-wrapper').find('.accordion').removeClass('active');
  }
  $(this).next('.accordion-body').slideToggle(300);
  $(this).next('.accordion-body').toggleClass('active');
  $(this).closest('.accordion').siblings().find('.accordion-head').find('.plus-icon').removeClass('minus');
  $(this).closest('.accordion').siblings().find('.accordion-head').removeClass('active');
  $(this).toggleClass('active');
  if($(this).hasClass('active')){
     $(this).parent().addClass('active');
  }else{
    $(this).parent().removeClass('active');
  }
  $(this).find('.plus-icon').toggleClass('minus');
});
*/
/*$('.accordion .accordion-head').click(function () {
  const $accordion = $(this).closest('.accordion');
  const $wrapper = $accordion.closest('.accordion-wrapper');

  // Close all siblings in the current wrapper only
  $wrapper.find('.accordion').not($accordion).removeClass('active');
  $wrapper.find('.accordion-body').not($(this).next()).slideUp(300).removeClass('active');
  $wrapper.find('.accordion-head').not(this).removeClass('active').find('.plus-icon').removeClass('minus');

  // Toggle the clicked one
  $(this).toggleClass('active');
  $accordion.toggleClass('active');
  $(this).next('.accordion-body').slideToggle(300).toggleClass('active');
  $(this).find('.plus-icon').toggleClass('minus');
});*/

$('.accordion .accordion-head').click(function () {
  const $accordion = $(this).closest('.accordion');
  const $wrapper = $accordion.closest('.accordion-wrapper');
  const $body = $(this).next('.accordion-body');

  // Close all siblings
  $wrapper.find('.accordion').not($accordion).removeClass('active');
  $wrapper.find('.accordion-body').not($body).slideUp(300).removeClass('active');
  $wrapper.find('.accordion-head').not(this).removeClass('active').find('.plus-icon').removeClass('minus');

  // Toggle clicked one
  $(this).toggleClass('active');
  $accordion.toggleClass('active');
  $body.slideToggle(300).toggleClass('active');
  $(this).find('.plus-icon').toggleClass('minus');

  // ⭐️ After opening animation completes, scroll it to top
  setTimeout(() => {
    // Determine offset based on device width
    const isMobile = window.innerWidth <= 768;   // you can adjust breakpoint
    const offsetAmount = isMobile ? 60 : 90;

    // Apply to the scroll line
    const offset = $(this).offset().top - offsetAmount;

    $('html, body').animate(
      { scrollTop: offset },
      300,
      'linear'
    );
  }, 310); // waits slightly longer than slideToggle(300)
});

/************************* COMMON ACCORDIAN JS END ***********************/

  
});
//======== FAQ JS END ===========

//Home page banner video play puase js start
/*$(document).ready(function() {
  if($('#hero-banner-video').length>0){
    var $video = $('#hero-banner-video');
    var $playIcon = $('.tplay-icon');
    var $hb_video_box = $('.hb_video_box');
    var $thumbnail = $('.hb__tthumbnail');
    // Show play button initially
    $playIcon.show();
  }
});*/

/*:::::::::::::::::::::::::: HOME PAGE BANNER VIDEO PLAY & PUASE JS START ::::::::::::::::::::::::::::*/

jQuery(document).on('click', '.hero_banner_video .tplay-icon', function () {
  if($('.hero_banner_video').find('#hero-banner-video').length > 0) {
    var $video = $('.hero_banner_video').find('#hero-banner-video');
    var $playIcon = $('.hero_banner_video .tplay-icon');
    var $hb_video_box = $('.hero_banner_video .hb_video_box');
    var $thumbnail = $('.hero_banner_video .hb__tthumbnail');
  
    // Show play button initially
    if ($video.get(0).paused) {
      $video.get(0).play();
      $playIcon.hide(); // Hide icon when playing
      $thumbnail.hide();
      $(this).parent('div').addClass('video_played');
    } else {
      $video.get(0).pause();
      $playIcon.show(); // Show icon when paused
      $thumbnail.show();
      $(this).parent('div').removeClass('video_played');
    }  
    // Optional: pause video when it ends and show play icon again
    $video.on('ended', function () {
      $playIcon.show();
    });
  }
});

jQuery(document).on("click",".hero_banner_video .hb_video_box.video_played",function(){
  if($('.hero_banner_video').find('#hero-banner-video').length > 0) {
    var $video = $('.hero_banner_video').find('#hero-banner-video');
    var $playIcon = $('.hero_banner_video .tplay-icon');
    var $hb_video_box = $('.hero_banner_video .hb_video_box');
    var $thumbnail = $('.hero_banner_video .hb__tthumbnail');
    $video.get(0).pause();
    $playIcon.show(); // Show icon when paused
    $thumbnail.show();
    $(this).removeClass('video_played');
  }
});

/*:::::::::::::::::::::::::: HOME PAGE BANNER VIDEO PLAY & PUASE JS END ::::::::::::::::::::::::::::*/

/*:::::::::::::::::::::::::: PDP PAGE VIDEO SLIDER PLAY & PUASE JS START ::::::::::::::::::::::::::::*/

jQuery(document).on('click', '.video-testimonials-wrapp .tplay-icon', function () {
  var $parent = jQuery(this).parent('div');
  var $videoEl = $parent.find('.tvideo');
  if ($videoEl.length === 0) {
    console.warn("Video element not found in this block.");
  }
  pauseAllVideos();
  showHideVideo();
  $videoEl.show();
  var video = $videoEl.get(0);
  if (video.paused) {
    video.play();
    video.muted = false;
    $parent.addClass('review-videos-active');
    $parent.find('.tthumbnail').hide();
    jQuery(this).hide();
  } else {
    //console.log("Paused video");
    video.pause();
    $parent.removeClass('review-videos-active');
    $parent.find('.tthumbnail').show();
    jQuery(this).show();
  }
});

jQuery(document).on("click",".video-testimonials-wrapp .slick-slide.slick-cloned.slick-active .review-videos.review-videos-active",function(){
  var $parent = jQuery(this);
  var $videoEl = $parent.find('.tvideo');

  if ($videoEl.length === 0) {
    console.warn("Video element not found in this block.");
    return;
  }
  
  $videoEl.show();
  var video = $videoEl.get(0);

  if (video.paused) {
    video.play();
    video.muted = false;
    $parent.addClass('review-videos-active');
    $parent.find('.tthumbnail').hide();
    $parent.find('.tplay-icon').hide();
  } else {
    pauseAllVideos();
    //console.log("ppppppp else  ");
    video.play();
    $parent.removeClass('review-videos-active');
    $parent.find('.tthumbnail').show();
    $parent.find('.tplay-icon').show();
  }
});
function pauseAllVideos() {
  jQuery('.tvideo').each(function () {
    this.pause();
    this.muted = true;
    var $videoContainer = jQuery(this).closest('.review-videos');
    $videoContainer.removeClass('review-videos-active');
    $videoContainer.find('.tthumbnail').show();
    $videoContainer.find('.tplay-icon').show();
  });
}
function showHideVideo(){
  jQuery('.video-testimonials-wrapp').find('.review-videos').removeClass('review-videos-active');
  jQuery('.video-testimonials-wrapp').find('.review-videos').find('.tvideo').hide();
  jQuery('.video-testimonials-wrapp').find('.review-videos').find('.tthumbnail').show();
  jQuery('.video-testimonials-wrapp').find('.review-videos').find('.tplay-icon').show();
}

/*:::::::::::::::::::::::::: PDP PAGE VIDEO SLIDER PLAY & PUASE JS END ::::::::::::::::::::::::::::*/


/*jQuery(document).on('click','.reviewbox .review-videos-active', function() {
  var videoObj = jQuery(this).find('.tvideo');
  videoObj.get(0).pause();
  videoObj.prop('muted', false);
  videoObj.hide();
  jQuery(this).parent('div').removeClass('review-videos-active');
  jQuery(this).parent('div').find('.tthumbnail').show();
  jQuery(this).show(); // Hide play button
});*/
// Pause video and show play button when clicking on the video area
/*jQuery(document).on('click','#hero-banner-video', function() {
  if (!$video.get(0).paused) {
    $video.get(0).pause();
    $hb_video_box.removeClass('video__play');
    $playIcon.show(); // Show play button again
  }
});*/
//Home page banner video play puase js end

//:: START :: Product Gallery :: ==================

$(".product---gallery-v1").find(".product__gallery").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: false,
    infinite: false,
    speed: 200,
    asNavFor: ".product__thumbnail",
    arrows: true,
    dots: false,
    draggable: true,
    focusOnSelect: false,
    prevArrow: '<button type="button" class="slick-prev" aria-label="Previous" tabindex="0" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none"><path d="M27.5488 32.9633L18.6111 24.0255L27.5488 15.0878" stroke="#262626" stroke-width="3.13714" stroke-linecap="square" stroke-linejoin="round"/></path></svg></button>',
    nextArrow: '<button type="button" class="slick-next" aria-label="Next" tabindex="0" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none"><path d="M20.4512 32.9633L29.3889 24.0255L20.4512 15.0878" stroke="#262626" stroke-width="3.13714" stroke-linecap="square" stroke-linejoin="round"/></path></svg></button>'
});

$(".product---gallery-v1").find(".product__thumbnail").slick({
    slidesToShow: 5.2,
    slidesToScroll: 1,
    asNavFor: ".product__gallery",
    dots: false,
    centerMode: false,
    focusOnSelect: true,
    speed: 200,
    infinite: false,
    arrows: false,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 4.2,
          slidesToScroll: 1
        }
      }
    ]
});

// jQuery(document).on("click",".zoom-gallery",function(){
//   jQuery('body').addClass("product-popup-open");
//   jQuery('.product-media-modal').attr('open','');
// });

// jQuery(document).on("click",".product-media-modal__toggle",function(){
//   jQuery('body').removeClass("product-popup-open");
// });

// jQuery(document).on("click",".hchoose-modal-button",function(){  
//   jQuery('.hchoose-modal').addClass('js-modal-open');
// });

// jQuery(document).on('click',".hchoose-close",function(){
//    jQuery('.hchoose-modal').removeClass('js-modal-open');
// });

//:: START :: Product Gallery :: ==================

/*
$(document).ready(function() {
  // Play icon click event
  $('.video-play-icon').on('click', function() {
        var $parent = $(this).parent();
        $('.video-box').addClass('review-videos-active');

        // Pause the currently playing video
        var $videoContainer = $parent.find('.tvideo, .tyoutube-video, .tvimeo-video');
        var $videoElement = $videoContainer.find('iframe, video');

        if ($videoElement.length && !$videoElement.get(0).paused) {
            $videoElement.get(0).pause();
        }

        // Hide thumbnail and play icon
        $parent.find('.tthumbnail').hide();
        $(this).hide(); // Hide the play icon that was clicked

        // Show and play the clicked video
        if ($videoContainer.length) {
            $videoContainer.show();
            if ($videoElement.length) {
                $videoElement.get(0).play();
            }
        }
    });
});
*/

// IMAGE SCROLL :: START

    $('.image-scroll .image-scroll-col').slick({
    slidesToShow: 7,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 8000,
    pauseOnHover: false,
    cssEase: 'linear',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
        }
      }
    ]
  });
// IMAGE SCROLL :: END


document.addEventListener('DOMContentLoaded', () => {
  const hideOverlay = card => {
    card.classList.add('review-videos-active');
    const play = card.querySelector('.tplay-icon');
    const thumb = card.querySelector('.tthumbnail');
    const detail = card.querySelector('.vt_poeople_details');
    if (play)   play.style.display   = 'none';
    if (thumb)  thumb.style.display  = 'none';
    if (detail) detail.style.display = 'none';
  };

  const showOverlay = card => {
    if(card!=null){
      card.classList.remove('review-videos-active');
      const play = card.querySelector('.tplay-icon');
      const thumb = card.querySelector('.tthumbnail');
      const detail = card.querySelector('.vt_poeople_details');
      if (play)   play.style.display   = '';
      if (thumb)  thumb.style.display  = '';
      if (detail) detail.style.display = '';
    }
  };
  
  function pauseOtherCards(activeCard) {
    document.querySelectorAll('.tvideo').forEach(video => {
      if (!activeCard.contains(video) && !video.paused) {
        video.pause();
        video.currentTime = 0;
        video.style.display = 'none';
        showOverlay(video.closest('.review-videos'));
      }
    });

    document.querySelectorAll('.tyoutube-video iframe').forEach(frame => {
      if (!activeCard.contains(frame)) {
        frame.contentWindow.postMessage(
          JSON.stringify({ event: 'command', func: 'pauseVideo', args: '' }),
          '*'
        );
        showOverlay(frame.closest('.review-videos'));
      }
    });

    document.querySelectorAll('.tvimeo-video iframe').forEach(frame => {
      if (!activeCard.contains(frame)) {
        frame.contentWindow.postMessage({ method: 'pause' }, '*');
        showOverlay(frame.closest('.review-videos'));
      }
    });
  }

  document.querySelectorAll('.tplay-icon').forEach(icon => {
    icon.addEventListener('click', function () {
      const isInsideHeroBanner = this.closest('.hero_banner_video');
      if (!isInsideHeroBanner) return;

      const card = this.closest('.review-videos');
      
      if (!card) return;
  
      const yt    = card.querySelector('.tyoutube-video iframe');
      const vm    = card.querySelector('.tvimeo-video iframe');
      const local = card.querySelector('.tvideo');
  
      pauseOtherCards(card);     // ← NEW: reliably pauses all others
      hideOverlay(card);         // hide icon, thumb, details
  
      console.log("local", local);
  
      if (yt) {
        yt.style.display = 'block';
        if (!yt.src.includes('autoplay=1')) {
          yt.src += (yt.src.includes('?') ? '&' : '?') + 'autoplay=1';
        }
      } else if (vm) {
        vm.style.display = 'block';
        if (!vm.src.includes('autoplay=1')) {
          vm.src += (vm.src.includes('?') ? '&' : '?') + 'autoplay=1';
        }
      } else if (local) {
        local.style.display = 'block';
        local.play();
      }
    });
  });


  document.querySelectorAll('.tvideo').forEach(video => {
    ['pause','ended'].forEach(evt => {
      video.addEventListener(evt, () => showOverlay(video.closest('.review-videos')));
    });
  });

  window.onYouTubeIframeAPIReady = () => {
    document.querySelectorAll('.tyoutube-video iframe').forEach(iframe => {
      const player = new YT.Player(iframe, {
        events: {
          onStateChange: e => {
            const st = e.data;
            const card = iframe.closest('.review-videos');
            if (st === YT.PlayerState.PLAYING) hideOverlay(card);
            if (st === YT.PlayerState.PAUSED || st === YT.PlayerState.ENDED) showOverlay(card);
          }
        }
      });
    });
  };

  document.querySelectorAll('.tvimeo-video iframe').forEach(iframe => {
    const vPlayer = new Vimeo.Player(iframe);
    const card = iframe.closest('.review-videos');
    vPlayer.on('play',  () => hideOverlay(card));
    vPlayer.on('pause', () => showOverlay(card));
    vPlayer.on('ended', () => showOverlay(card));
  });
});
//:: END :: sections/video-testimonials.liquid  ::

//======== TEXT SCROLL JS END =========
$('.text-scroll-col').slick({
  slidesToShow: 8,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 0,
  speed: 8000,
  arrows:false,
  pauseOnHover: false,
  cssEase: 'linear',
  variableWidth: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 769,
      settings: {
        slidesToShow: 2,
        variableWidth: true,
        slidesToScroll: 1,
      }
    }
  ]
});
//======== TEXT SCROLL JS END =========

jQuery(document).on('change','.drawer_routine_box .add__select_custom_upsell',function(){
  if(jQuery(this).parent().find('.add__custom_loader').length>0){
    jQuery(this).parent().find('.add__custom_loader').addClass('show');
    jQuery(this).parent().find('.add__select_custom_upsell').hide();
  }
  var variantId = jQuery(this).val();
  var productId = jQuery(this).attr('data-pid');
  addToCart(variantId,productId);
});

jQuery(document).on('click','.drawer_routine_box .add__btn_custom__upsell',function(){
  if(jQuery(this).parent().find('.add__custom_loader').length>0){
    jQuery(this).parent().find('.add__custom_loader').addClass('show');
    jQuery(this).parent().find('.add__btn_custom__upsell').hide();
  }
  var variantId = jQuery(this).attr('data-vid');
  var productId = jQuery(this).attr('data-pid');
  addToCart(variantId,productId);
});
/********************** PDP PAGE STICKY BUTTON ADD TO CART **********************/

/*jQuery(document).on('click','.sticky_product_bar .sticky-pdp-atc',function(){
  var variantId = jQuery('.product').find('.product__info-container').find('form').find('input[name="id"]').val();
  var productId = jQuery('.product').find('.product__info-container').find('form').find('input[name="product-id"]').val();
  var objBtn = '';
  if(jQuery(this).find('.btn_loader_btn').length>0){
    objBtn = jQuery(this).find('.btn_loader_btn');
  }
  //addToCart(variantId,productId,objBtn);
  if(jQuery(".product_buybutton .product-form__submit[name='add']").length>0){
    jQuery(".product_buybutton .product-form__submit[name='add']").trigger("click");
  }
  stickyButtonPDP();
});*/

jQuery(document).on('click', '.sticky_product_bar .sticky-pdp-atc', function (e) {
  e.preventDefault();

  // Primary target
  let $target = jQuery("variant-radios.product_bundle");

  // Fallback target
  if ($target.length === 0) {
    $target = jQuery(".product_price_block");
  }

  if ($target.length > 0) {
    const offset = $target.offset().top - 60;

    jQuery('html, body').animate(
      { scrollTop: offset },
      200,          // duration
      "linear"      // constant speed
    );
  }

  stickyButtonPDP();
});

function stickyButtonPDP(){
  var objbutton = jQuery('.sticky_product_bar');
  var interpId = setInterval(function(){
    if(jQuery(".product_buybutton .product-form__submit[name='add']").length>0){
      if(jQuery(".product_buybutton .product-form__submit[name='add']").hasClass('loading')){
        objbutton.find('.loading__spinner').removeClass('hidden');
        objbutton.find('.sticky-pdp-atc').addClass('loading');
      }else{
        objbutton.find('.loading__spinner').addClass('hidden');
        objbutton.find('.sticky-pdp-atc').removeClass('loading');
        clearInterval(interpId);
      }
    }
  },100);
}

jQuery(document).on("click",".product_buybutton .product-form__submit[name='add']",function(){
  var objbutton = jQuery(this);
  var interId = setInterval(function(){
    if(objbutton.hasClass('loading')){
      objbutton.find('.loading__spinner').removeClass('hidden');
    }else{
      objbutton.find('.loading__spinner').addClass('hidden');
      clearInterval(interId);
    }
  },100);
});

function addToCart(variantId, productId,objBtn='') {
  if (!variantId) {
    console.error("Error: Missing or invalid variant ID:", variantId);
    return;
  }
  if(objBtn!=""){
    objBtn.addClass('show');
    jQuery('.sticky_product_grid').find('.sticky-pdp-atc').attr('disabled',true);
  }

  var formData = {
    items: [{ id: variantId, quantity: 1 }],
  };

  //console.log("Attempting to add to cart:", formData);

  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: JSON.stringify(formData),
    contentType: "application/json",
    dataType: "json",
    success: function (response) {
      //console.log("Added to cart successfully:", response);
      customdrawerOpen(productId);
      setTimeout(function(){
        if(objBtn!=""){
          jQuery('.sticky_product_grid').find('.sticky-pdp-atc').removeAttr('disabled');
          objBtn.removeClass('show');
        }
      },1000);
    },
    error: function (xhr, status, error) {
      //console.log("errr",xhr.responseText);
      let response = {};
      try {
        response = JSON.parse(xhr.responseText);
      } catch (e) {
        console.error("Failed to parse error response:", e);
      }
    
      alert("Error adding to cart: " + (response.message || "Unknown error"));
    
      setTimeout(function () {
        if (objBtn != "") {
          jQuery('.sticky_product_grid').find('.sticky-pdp-atc').removeAttr('disabled');
          objBtn.removeClass('show');
        }
      }, 1000);

    },
  });
}
/********************** PDP PAGE STICKY BUTTON ADD TO CART **********************/

function customdrawerOpen(productid){
  if(jQuery('.cart-drawer .drawer_routine_box').find('.routine_product_col[data-col-pid="'+productid+'"]').length>0){
    jQuery('.cart-drawer .drawer_routine_box').find('.routine_product_col[data-col-pid="'+productid+'"]').hide();
  }
  
  upsellProductHideShow();
  var cartDrawer = document.querySelector("cart-drawer");
  if (cartDrawer) {
    cartDrawer.classList.remove('is-empty');
    $.ajax({
      url: "/?sections=cart-drawer,cart-icon-bubble",
      type: "GET",
      dataType: "json",
      success: function (parsedState) {
        if (!parsedState || !parsedState["cart-drawer"]) {
          console.error("Error: cart-drawer section not found", parsedState);
          return;
        }
        cartDrawer.renderContents({
          sections: {
            "cart-drawer": parsedState["cart-drawer"],
            "cart-icon-bubble": parsedState["cart-icon-bubble"],
          },
        });
        jQuery('.add__custom_loader').removeClass('show');
        jQuery('.add__btn_custom__upsell').show();
      }
    });
  }
}

jQuery(document).ready(function(){
  var upsellInter = setInterval(function(){
    if(jQuery('.cart-drawer').find('.drawer_routine_box').length > 0){
      upsellProductHideShow();
    }
  },10);
});

function upsellProductHideShow(){
  if(jQuery('.cart-drawer').find('.cart-items .cart-item').length>0 && jQuery('.drawer_routine_box').find('.routine_product_col').length>0){
    var totalUpsellCount = parseInt(jQuery('#drawer_product_count').val());
    var totalUpsellVisibleCount = 0;
    jQuery('.drawer_routine_box').find('.routine_product_col').each(function() {
      if(jQuery(this).css('display')=='none'){
         totalUpsellVisibleCount++;
      }
    });
    if(totalUpsellCount==totalUpsellVisibleCount){
      jQuery('.cart-drawer').find('.drawer_routine_box').hide();
    }else{
      jQuery('.cart-drawer').find('.drawer_routine_box').show();
    }
  }
}

// product gallery + zoom + fancybox -- START

Fancybox.bind("[data-fancybox]", {
  // Your custom options...

  on: {
    reveal: (fancybox, slide) => {
      // Wait for image to be in DOM
      $('.fancybox__content img').each(function () {
        const $img = $(this);

        // Avoid double-wrapping
        if (!$img.parent().hasClass('zoom-container')) {
          $img.wrap('<div class="zoom-container"></div>');
        }

        // Destroy any existing zoom and re-initialize
        $img.parent().trigger('zoom.destroy').zoom();
      });
    }
  }
});

$(document).ready(function(){
  $('.zoom-container').zoom();
});
//

jQuery(document).on("click", ".product__media-wrapper .zoom-gallery", function () {
  const $currentSlide = jQuery('.product--media-item.grid__item.slick-current.slick-active');
  const $fancyboxLink = $currentSlide.find('a.fancybox-href');
  if ($fancyboxLink.length > 0) {
    $fancyboxLink[0].click();
    setTimeout(function(){
      $('.fancybox__content img').parent().zoom();
    },1000);
  }
});

// product gallery + zoom + fancybox -- END

jQuery(document).on('change','.add__btn_custom_sel',function(){
  var variantId = jQuery(this).val();
  if(variantId != "" && variantId != undefined){
    $(this).val('');
    $(this).addClass('hide');
    $(this).parent().find('[name="id"]').val(variantId);
    $(this).parent().find('[name="add"').trigger('click');
  }
});

// Video List video JS START
jQuery(document).ready(function($) {
  $('.video-play-icon').on('click', function () {
    var $icon = $(this);
    var $card = $icon.closest('.video-box');
    var $carddetails = $card.find('.vt_poeople_details');
    var $youtubeVideo = $card.find('.tyoutube-video iframe');
    var $vimeoVideo = $card.find('.tvimeo-video iframe');
    var $localVideo = $card.find('.tvideo');
    var $thumbnail = $card.find('.video_thumbnail');

    $icon.hide();
    $card.addClass('review-videos-active');

    if ($thumbnail.length) {
      $thumbnail.hide();
    }
    if ($carddetails.length) {
      $carddetails.hide();
    }

    // Handle YouTube
    if($youtubeVideo.length) {
      $youtubeVideo.attr('src', $youtubeVideo.data('src') + '&autoplay=1&mute=1');
      $youtubeVideo.removeClass('lazyload').show();
      $youtubeVideo.trigger('click');
    }

    // Handle Vimeo
    else if ($vimeoVideo.length) {
      $vimeoVideo.attr('src', $vimeoVideo.data('src') + '&autoplay=1');
      $vimeoVideo.removeClass('lazyload').show();
    }

    // Handle Local video
    else if ($localVideo.length) {
      $localVideo.show().get(0).play();
    }
  });
});
// Video List video JS END

// TRUSTED REVIEW JS START
$(document).ready(function() {
  $('.tpplay-icon').on('click', function () {
    var $icon = $(this);
    var $card = $icon.closest('.tr_col_banner');
    var $localVideo = $card.find('.tvideo');
    var $thumbnail = $card.find('.tthumbnail');

    // Hide play icon and thumbnail
    $icon.hide();
    $card.addClass('tr_col_banner-active');

    if ($thumbnail.length) {
      $thumbnail.hide();
    }
    if ($carddetails.length) {
      $carddetails.hide();
    }

    // Handle YouTube
    if($youtubeVideo.length) {
      $youtubeVideo.attr('src', $youtubeVideo.data('src') + '&autoplay=1&mute=1');
      $youtubeVideo.removeClass('lazyload').show();
      $youtubeVideo.trigger('click');
    }

    // Handle Vimeo
    else if ($vimeoVideo.length) {
      $vimeoVideo.attr('src', $vimeoVideo.data('src') + '&autoplay=1');
      $vimeoVideo.removeClass('lazyload').show();
    }

    // Handle Local video
    else if ($localVideo.length) {
      $localVideo.show().get(0).play();
    }
  });
  
});
jQuery(document).on('click','.br_banner_video', function() {
    var $video = jQuery(this).find('.tvideo');
    if (!$video.get(0).paused) {
      jQuery(this).parent().parent().parent('div').removeClass('tr_col_banner-active');
    }else{
      jQuery(this).parent().parent().parent('div').addClass('tr_col_banner-active');
    }
  });
  // Pause video and show play button when clicking on the video area
  /*jQuery(document).on('click','.tvideo,.tpplay-icon', function() {
    var $icon = $(this);
    var $card = $icon.closest('.tr_col_banner');
    var $localVideo = $card.find('.tvideo');
    var $thumbnail = $card.find('.tthumbnail');
    //$card.addClass('tr_col_banner-active');

    if ($thumbnail.length) {
      $thumbnail.hide();
    }
    // Handle YouTube
    if($youtubeVideo.length) {
      $youtubeVideo.attr('src', $youtubeVideo.data('src') + '&autoplay=1&mute=1');
      $youtubeVideo.removeClass('lazyload').show();
      $youtubeVideo.trigger('click');
    }

    // Handle Vimeo
    else if ($vimeoVideo.length) {
      $vimeoVideo.attr('src', $vimeoVideo.data('src') + '&autoplay=1');
      $vimeoVideo.removeClass('lazyload').show();
    }
    if (!$localVideo.get(0).paused) {
      $localVideo.get(0).pause();
      $card.removeClass('tr_col_banner-active');
      $icon.hide(); // Show play button again
    }else{
      $card.addClass('tr_col_banner-active');
       $localVideo.show().get(0).play();
    }
  });
});

/*$(document).ready(function() {
  if($('.trusted_review_container').length>0){
   
    var $playIcon = $('.tpplay-icon');
    var $hb_video_box = $('.hb_video_box');
    var $thumbnail = $('.tthumbnail');
  
    // Show play button initially
    $playIcon.show();
  
    jQuery(document).on('click','.tpplay-icon', function() {
       var $video = jQuery(this).next('.tvideo').eq(0);
      var $hb_video_box = jQuery(this).closest('.tr_col_banner');
      if ($hb_video_box.hasClass('tr_col_banner-active')) {
        $video.get(0).pause();
        $hb_video_box.removeClass('tr_col_banner-active');
        $playIcon.show(); // Show play button again
      } else {
        if ($video.get(0).paused) {
          $video.get(0).play();
          $video.prop('muted', false);
          $playIcon.hide(); // Hide play button
          $hb_video_box.addClass('tr_col_banner-active');
          if ($thumbnail.length) {
            $thumbnail.hide(); // Hide thumbnail if exists
          }
        }
      }
    });
  
    // Pause video and show play button when clicking on the video area
    jQuery(document).on('click','.br_banner_video', function() {
      var $video = jQuery(this).next('.tvideo').eq(0);
      if (!$video.get(0).paused) {
        $video.get(0).pause();
        jQuery(this).closest('.tr_col_banner').removeClass('tr_col_banner-active');
        $playIcon.show(); // Show play button again
      }
    });
  }
});*/
// TRUSTED REVIEW JS END

$('.tab-button-wrapper .tab-button').on('click', function(e) {
  e.preventDefault();
  
  // Grab the current href -- that will match the id of the right
  // content element.
  var attr = $(this).attr('href');
  
  // Make the correct tab active, and mark all other tabs as non-active.
  $(this).addClass('is-active').siblings().removeClass('is-active');
  
  // Make the right content visible, hide all other content.
  $(attr).addClass("show").siblings().removeClass("show");
});

// sticky add to cart product
$(document).ready(function() {
    getStickyProductHeight();
});
function getStickyProductHeight(){
  var classStickyProductHeight = jQuery('.sticky_product_bar').height();
  document.documentElement.style.setProperty('--sticky-product', classStickyProductHeight + 'px');
}
$(window).on('resize', function () {
  getStickyProductHeight();
});
// sticky add to cart product

// PDP PRODUCT COMPARISION START 
$('.new_comparison_popup .comparison_popup').slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1
});
jQuery(document).on("click", ".bottom-button .bottom_button_text", function () {
  jQuery('body').toggleClass("drawer-active");
  $('.new_comparison_popup .comparison_popup').slick('refresh');
});
jQuery(document).on("click", ".drawer-active .comparison_popup_close", function (event) {
  jQuery('body').removeClass("drawer-active");
});
// PDP PRODUCT COMPARISION END 

$(function () {
  const $btn = $('.product-form__submit');   // original ATC button
  const $bar = $('.sticky_product_bar');     // sticky bar you want to toggle
  if (!$btn.length || !$bar.length) return;  // fail‑safe
  /* 2. Re‑check on scroll, resize, or first load */
  $(window).on('scroll resize load', function () {
    const btnBottom = $btn.offset().top + $btn.outerHeight();
    const winTop    = $(this).scrollTop();
    /* 3. If ATC button is ABOVE the viewport → show sticky bar */
    if (btnBottom < winTop) {
      $bar.addClass('is-visible');
    } else {
      $bar.removeClass('is-visible');
    }
  }).trigger('scroll'); // run once on load
});

/*:::::::::::::::::::::::::: CONTACT PAGE SUBMIT SUCCESS MSG SHOW JS START ::::::::::::::::::::::::::::*/
function getQueryParam(param) {
  var urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(param);
}

jQuery(document).ready(function(){
  if(jQuery('body').hasClass('page__contact')){
    var fullUrl = window.location.href;
    var pathSegments = window.location.pathname.split('/').filter(Boolean);
    var lastSegment = pathSegments[pathSegments.length - 1];
    // Example usage:
    var contactsubmit = getQueryParam('contact_posted');
    if(contactsubmit!=null && contactsubmit!=undefined){
      if(jQuery('body.page__contact').find('.contact--form').find('.form-error').length){
        setTimeout(function(){
          jQuery('body.page__contact').find('.contact--form').find('.form-error').hide();
        },3000);
      }
      if(jQuery('body.page__contact').find('.contact--form').find('.form-sucsess').length>0){
        jQuery('body.page__contact').find('.contact--form').find('.form-sucsess')[0].style.setProperty('display', 'block', 'important');
        setTimeout(function(){
          jQuery('body.page__contact').find('.contact--form').find('.form-sucsess')[0].style.setProperty('display', 'none', 'important');
        },3000);
      }
    }
  }
});
/*:::::::::::::::::::::::::: CONTACT PAGE SUBMIT SUCCESS MSG SHOW END START :::::::::::::::::::::::::::*/
